/**
 * MRL Product Selector - Consolidated Bundle for Shopify
 * Combines: ProductDesignator, sku_v2_to_sku_v1, ViewModel, and product_selector
 *
 * Author: Jeff McKnight
 * Generated: 2024
 *
 * This file consolidates 4 ES6 modules into a single Shopify-compatible script.
 * All code is wrapped in an IIFE to avoid global scope pollution.
 */

(function() {
    'use strict';

    // ============================================================================
    // ProductDesignator Class
    // ============================================================================

    /**
     * @property value {String} the designator code
     * @property isSelected {Boolean} should the product option be selected in the Product Selector
     * @property label {String} the display label for the option
     */
    class ProductDesignator {
        constructor(value, isSelected, label) {
            this.value = value;
            this.isSelected = isSelected;
            this.label = label;
        }
    }

    // ============================================================================
    // SKU v2 to SKU v1 Mapping
    // ============================================================================

    /**
     * Maps SKUv2 keys to SKUv1 values. We use this to display the legacy 6-char part numbers when possible
     * @see https://gitlab.com/mrltapes/engineering/mrl-catalog-number-decoder/-/blob/main/MRLdecoder.py
     * @type {Map<string, string>}
     */
    const skuV2ToSkuV1 = new Map([
        ["243-106-480-118", "20J205"],
        ["251-106-480-119", "20L221"],
        ["221-105-460-119", "21F101"],
        ["221-102-460-118", "21F101-A"],
        ["221-102-480-110", "21F201-A"],
        ["221-102-490-111", "21F301-A"],
        ["221-102-510-116", "21F401-A"],
        ["241-101-460-115", "21J103"],
        ["241-101-460-610", "21J103-R"],
        ["243-101-460-111", "21J105"],
        ["243-101-460-616", "21J105-R"],
        ["241-101-480-117", "21J203"],
        ["241-101-480-612", "21J203-R"],
        ["243-101-480-113", "21J205"],
        ["243-101-480-618", "21J205-R"],
        ["241-102-490-115", "21J303"],
        ["241-101-490-118", "21J303-A"],
        ["241-102-490-610", "21J303-R"],
        ["241-101-490-613", "21J303A-R"],
        ["243-101-490-114", "21J305"],
        ["241-101-510-113", "21J403"],
        ["241-101-510-618", "21J403-R"],
        ["243-101-510-119", "21J405"],
        ["243-101-510-614", "21J405-R"],
        ["241-101-540-116", "21J503"],
        ["241-101-540-611", "21J503-R"],
        ["243-101-540-112", "21J505"],
        ["251-101-460-112", "21L121"],
        ["251-101-460-617", "21L121-R"],
        ["251-101-480-114", "21L221"],
        ["251-101-480-619", "21L221-R"],
        ["251-101-490-115", "21L321"],
        ["251-101-510-110", "21L421"],
        ["251-101-510-615", "21L421-R"],
        ["251-101-540-113", "21L521"],
        ["231-102-460-115", "21T102"],
        ["231-102-460-610", "21T102-R"],
        ["233-102-460-111", "21T104"],
        ["233-102-460-014", "21T104-CP"],
        ["233-102-460-616", "21T104-R"],
        ["231-102-480-117", "21T202"],
        ["231-102-480-612", "21T202-R"],
        ["233-102-480-113", "21T204"],
        ["233-102-480-618", "21T204-R"],
        ["231-102-490-118", "21T302"],
        ["231-102-490-613", "21T302-R"],
        ["233-102-490-114", "21T304"],
        ["231-102-510-113", "21T402"],
        ["233-102-510-119", "21T404"],
        ["233-102-510-119", "21T404-A"],
        ["233-102-510-614", "21T404-R"],
        ["231-102-540-116", "21T502"],
        ["233-102-542-110", "21T504"],
        ["290-201-000-119", "22A107"],
        ["290-202-000-116", "22A108"],
        ["221-301-360-110", "23F101-A"],
        ["243-301-460-113", "23J137"],
        ["243-301-480-115", "23J237"],
        ["241-301-390-117", "23J349"],
        ["251-301-460-114", "23L138"],
        ["233-301-360-113", "23T136"],
        ["233-301-380-115", "23T236"],
        ["231-301-390-110", "23T348"],
        ["221-402-360-118", "24F101-A"],
        ["241-402-460-117", "24J103"],
        ["243-402-460-111", "24J105"],
        ["243-402-480-113", "24J205"],
        ["241-402-390-115", "24J303"],
        ["251-402-460-112", "24L121"],
        ["233-402-360-111", "24T104"],
        ["233-402-380-113", "24T204"],
        ["231-402-390-118", "24T302"],
        ["221-701-360-114", "27F101-A"],
        ["221-701-380-116", "27F201-A"],
        ["241-701-460-111", "27J103"],
        ["243-701-460-117", "27J105"],
        ["251-701-460-118", "27L121"],
        ["231-701-360-111", "27T102"],
        ["233-701-360-117", "27T104"],
        ["233-701-380-119", "27T204"],
        ["221-801-360-115", "28F101-A"],
        ["241-801-460-112", "28J103"],
        ["243-801-460-118", "28J105"],
        ["243-801-480-110", "28J205"],
        ["241-801-390-112", "28J303"],
        ["251-801-460-119", "28L121"],
        ["231-801-360-112", "28T102"],
        ["233-801-360-118", "28T104"],
        ["233-801-380-110", "28T204"],
        ["231-801-390-115", "28T302"],
        ["321-104-462-122", "31F156-A"],
        ["321-104-482-124", "31F256-A"],
        ["321-104-512-120", "31F456-A"],
        ["343-103-462-125", "31J119"],
        ["341-103-462-129", "31J129"],
        ["343-103-482-127", "31J219"],
        ["343-103-482-622", "31J219-R"],
        ["341-103-482-121", "31J229"],
        ["341-103-482-626", "31J229-R"],
        ["343-103-492-128", "31J319"],
        ["343-103-482-622", "31J319-R"],
        ["341-104-492-129", "31J329"],
        ["341-103-492-122", "31J329-A"],
        ["343-103-512-123", "31J419"],
        ["343-103-512-628", "31J419-R"],
        ["341-103-512-127", "31J429"],
        ["341-103-512-622", "31J429-R"],
        ["343-103-542-126", "31J519"],
        ["341-103-542-120", "31J529"],
        ["351-103-462-126", "31L120"],
        ["351-103-462-621", "31L120-R"],
        ["351-103-482-128", "31L220"],
        ["351-103-482-623", "31L220-R"],
        ["351-103-492-129", "31L320"],
        ["351-103-512-124", "31L420"],
        ["351-103-512-629", "31L420-R"],
        ["351-103-542-127", "31L520"],
        ["333-104-462-125", "31T118"],
        ["331-104-462-129", "31T128"],
        ["333-104-482-127", "31T218"],
        ["331-104-482-121", "31T228"],
        ["331-104-492-122", "31T328"],
        ["333-104-512-123", "31T418"],
        ["331-104-512-127", "31T428"],
        ["333-104-542-126", "31T518"],
        ["321-301-362-120", "33F156-A"],
        ["321-301-382-122", "33F256-A"],
        ["343-301-462-123", "33J140"],
        ["343-301-482-125", "33J240"],
        ["341-301-392-127", "33J351"],
        ["351-301-462-124", "33L141"],
        ["333-301-362-123", "33T139"],
        ["331-301-392-120", "33T350"],
        ["321-402-362-128", "34F156-A"],
        ["321-402-382-120", "34F256-A"],
        ["343-402-462-121", "34J119"],
        ["343-402-482-123", "34J219"],
        ["341-402-482-127", "34J229"],
        ["341-402-392-125", "34J329"],
        ["351-402-462-122", "34L120"],
        ["351-402-482-124", "34L220"],
        ["333-402-362-121", "34T118"],
        ["331-402-392-128", "34T328"],
        ["321-701-362-124", "37F156-A"],
        ["343-701-462-127", "37J119"],
        ["341-701-462-121", "37J129"],
        ["343-701-482-129", "37J219"],
        ["351-701-462-128", "37L120"],
        ["333-701-362-127", "37T118"],
        ["331-701-362-121", "37T128"],
        ["321-801-362-125", "38F156-A"],
        ["321-801-382-127", "38F256-A"],
        ["343-801-462-128", "38J119"],
        ["341-801-462-122", "38J129"],
        ["351-801-462-129", "38L120"],
        ["333-801-362-128", "38T118"],
        ["331-801-362-122", "38T128"],
        ["333-801-382-120", "38T218"],
        ["421-104-462-134", "41F157-A"],
        ["421-104-482-136", "41F257-A"],
        ["443-103-462-137", "41J116"],
        ["441-103-462-131", "41J126"],
        ["441-103-462-636", "41J126-R"],
        ["443-103-482-139", "41J216"],
        ["441-103-482-133", "41J226"],
        ["441-103-482-634", "41J226-A"],
        ["441-103-482-638", "41J226-R"],
        ["441-104-492-131", "41J326"],
        ["441-103-492-134", "41J326-A"],
        ["441-104-492-131", "41J326-B"],
        ["443-103-512-135", "41J416"],
        ["443-103-512-630", "41J416-R"],
        ["441-103-512-139", "41J426"],
        ["443-103-542-138", "41J516"],
        ["441-103-542-132", "41J526"],
        ["451-103-462-138", "41L117"],
        ["451-103-482-130", "41L217"],
        ["451-103-492-131", "41L317"],
        ["451-103-512-136", "41L417"],
        ["451-103-512-631", "41L417-R"],
        ["451-103-542-139", "41L517"],
        ["433-104-462-137", "41T115"],
        ["431-104-462-131", "41T125"],
        ["433-104-482-139", "41T215"],
        ["431-104-482-133", "41T225"],
        ["431-104-492-134", "41T325"],
        ["421-301-362-132", "43F157-A"],
        ["443-301-462-135", "43J143"],
        ["441-301-392-139", "43J353"],
        ["451-301-462-136", "43L144"],
        ["433-301-362-135", "43T142"],
        ["431-301-392-132", "43T352"],
        ["421-402-362-130", "44F157-A"],
        ["443-402-462-133", "44J116"],
        ["441-402-462-137", "44J126"],
        ["441-402-392-137", "44J326"],
        ["451-402-462-134", "44L117"],
        ["433-402-362-133", "44T115"],
        ["431-402-392-130", "44T325"],
        ["421-701-362-136", "47F157-A"],
        ["443-701-462-139", "47J116"],
        ["441-701-462-133", "47J126"],
        ["451-701-462-130", "47L117"],
        ["433-701-362-139", "47T115"],
        ["431-701-362-133", "47T125"],
        ["421-801-362-137", "48F157-A"],
        ["443-801-462-130", "48J116"],
        ["441-801-462-134", "48J126"],
        ["451-801-462-131", "48L117"],
        ["451-801-482-133", "48L217"],
        ["433-801-362-130", "48T115"],
        ["431-801-362-134", "48T125"],
        ["543-103-462-149", "51J113"],
        ["541-103-462-143", "51J123"],
        ["543-103-482-141", "51J213"],
        ["543-103-482-646", "51J213-R"],
        ["541-103-482-145", "51J223"],
        ["543-103-502-146", "51J313"],
        ["541-104-492-143", "51J323"],
        ["541-103-492-146", "51J323-A"],
        ["543-103-512-147", "51J413"],
        ["543-103-512-642", "51J413-R"],
        ["541-103-512-141", "51J423"],
        ["543-103-542-140", "51J513"],
        ["541-103-542-144", "51J523"],
        ["551-103-462-140", "51L114"],
        ["551-103-482-142", "51L214"],
        ["551-103-492-143", "51L314"],
        ["551-103-512-148", "51L414"],
        ["551-103-542-141", "51L514"],
        ["551-103-552-142", "51L614"],
        ["533-104-462-149", "51T112"],
        ["531-104-462-143", "51T122"],
        ["533-104-482-141", "51T212"],
        ["531-104-482-145", "51T222"],
        ["531-104-492-141", "51T322"],
        ["531-104-492-146", "51T322-B"],
        ["543-301-462-147", "53J146"],
        ["541-301-392-141", "53J355"],
        ["551-301-462-148", "53L147"],
        ["533-301-362-147", "53T145"],
        ["531-301-392-144", "53T354"],
        ["543-402-462-145", "54J113"],
        ["541-402-392-149", "54J323"],
        ["551-402-462-146", "54L114"],
        ["533-402-362-145", "54T112"],
        ["531-402-392-142", "54T322"],
        ["543-701-462-141", "57J113"],
        ["541-701-462-145", "57J123"],
        ["551-701-462-142", "57L114"],
        ["533-701-362-141", "57T112"],
        ["531-701-362-145", "57T122"],
        ["543-801-462-142", "58J113"],
        ["541-801-462-146", "58J123"],
        ["543-801-482-144", "58J213"],
        ["551-801-462-143", "58L114"],
        ["533-801-362-142", "58T112"],
        ["531-801-362-146", "58T122"]
    ]);

    function hasV1Sku(skuString) {
        return (skuV2ToSkuV1.get(skuString) != null);
    }

    // ============================================================================
    // Product Lookup with Caching
    // ============================================================================

    /**
     * Cache product lookups to avoid repeated API calls
     * Maps SKU -> product handle (or null if not found)
     */
    const productHandleCache = new Map();

    /**
     * Find a product by SKU using Shopify's search with custom JSON template
     * Caches results to avoid repeated API calls
     *
     * This uses a custom search template (templates/search.json.liquid) that returns
     * JSON with all variant SKUs, unlike the predictive search API which only indexes
     * the first variant's SKU.
     *
     * @param {string} sku - The SKU to search for
     * @returns {Promise<{handle: string, variantId: number}|null>} Object with handle and variantId, or null if not found
     */
    async function findProductBySku(sku) {
        // Check cache first
        if (productHandleCache.has(sku)) {
            return productHandleCache.get(sku);
        }

        try {
            // Use custom JSON search template - searches ALL variant SKUs
            const response = await fetch(
                `/search?type=product&q=${encodeURIComponent(sku)}&view=json`
            );

            if (!response.ok) {
                console.warn('Product search failed:', response.status);
                productHandleCache.set(sku, null);
                return null;
            }

            const data = await response.json();

            console.log('=== Search Response for SKU:', sku, '===');
            console.log(JSON.stringify(data, null, 2));
            console.log('===================');

            // Check if we found any products
            if (data.results && data.results.length > 0) {
                // Look for a product with a variant that has a matching SKU
                for (const product of data.results) {
                    if (product.variants && product.variants.length > 0) {
                        const matchingVariant = product.variants.find(variant =>
                            variant.sku && variant.sku.toUpperCase() === sku.toUpperCase()
                        );

                        if (matchingVariant) {
                            const result = {
                                handle: product.handle,
                                variantId: matchingVariant.id
                            };
                            productHandleCache.set(sku, result);
                            console.log(`Found product for SKU ${sku}: ${result.handle} (variant: ${result.variantId})`);
                            return result;
                        }
                    }
                }
            }

            // Not found - cache the null result
            console.log(`No product found for SKU ${sku}`);
            productHandleCache.set(sku, null);
            return null;
        } catch (error) {
            console.error('Error finding product by SKU:', error);
            return null;
        }
    }

    // ============================================================================
    // ViewModel Class
    // ============================================================================

    /**
     * Keeps track of the state for product_selector.html page.  There are some dependencies and limitations between the
     * various SKU parameters, so we need to update things in the right order.
     *
     * @property { string } widthCode maps to the tape width and is independent of all other parameters
     * @property { string } speedCode maps to the intended playback speed
     * @property { string } equalizationCodeV3 maps to the equalization for the tape
     * @property { string } testSignalsCode three-digit ID that indicate what the test signal program is
     * @property { string } referenceFluxivityCodeV3 two-digit code that indicates the fluxivity that 0dB is referenced to
     * @property { string } durationCode indicates how long the tape is
     */
    class ViewModel {
        constructor(widthCode = WIDTH_CODE_6MM,
                    speedCode = SPEED_CODE_FAST,
                    equalizationCode = EQ_NAB_380,
                    testSignalsCode = TEST_SIGNAL_101,
                    referenceFluxivityCode = REFERENCE_FLUXIVITY_48,
                    fringingCompensationCode = FRINGING_COMP_DISABLED,
                    durationCode = DURATION_6_MIN,
                    unitSystem = UNIT_SYSTEM_IMPERIAL) {
            this.widthCode = widthCode;
            this.speedCode = speedCode;
            this.equalizationCodeV3 = equalizationCode;
            this.testSignalsCode = testSignalsCode;
            this.referenceFluxivityCodeV3 = referenceFluxivityCode;
            this.fringingCompensationCode = fringingCompensationCode;
            this.durationCode = durationCode;
            this.packagingCode = '1';
            this.unitSystem = unitSystem;
        }

        /**
         * We hide the German Standard fluxivities for the Flutter and Speed tape because we only make it at the 250nWb/m
         * ANSI standard level. It is visible for all other signal programs.
         *
         * @returns {boolean} true if the German Standard fluxivity group should be visible; false if it should be hidden
         */
        isGermanFluxivityGroupVisible() {
            return (this.testSignalsCode !== TEST_SIGNAL_570);
        }

        /**
         * Convert the Reference Fluxivity SKU code to a dB level with +/- explicitly indicated.
         * @returns {string} the Reference Fluxivity in dB, relative to 180 nWb/m
         */
        referenceFluxivityDb() {
            let dB = this.#referenceFluxivityCodeV2() - 45;
            let prefix = "";
            if (dB > 0) {
                prefix = "+";
            }
            return prefix + dB + " dB";
        }

        /**
         * Return SKUv1 (the legacy 6-char version), if possible.  Otherwise, return the SKUv2 (the newer 12-digit version).
         * @returns {string}
         */
        sku() {
            let v2 = this.skuV2String();
            let v1 = skuV2ToSkuV1.get(v2);
            if (v1 != null) return v1;
            return v2;
        }

        /**
         * The 12-digit part number
         * @returns {string}
         */
        skuV2String() {
            return this.widthCode
                + this.#playbackSpeedCodeV2()
                + this.#equalizationCodeV2()
                + '-'
                + this.testSignalsCode
                + '-'
                + this.#referenceFluxivityCodeV2()
                + this.fringingCompensationCode
                + '-'
                + this.packagingCode
                + this.durationCode
                + this.#checkDigit();
        }

        /**
         * @returns {ProductDesignator[]}
         */
        supportedDurationDesignators() {
            return this.#supportedDesignators(this.#supportedDurationOptions(), durationCodeToLabel, this.durationCode);
        }

        /**
         * For multifrequency tapes (CVV 101..104), we only support the standard options.
         *
         * @returns {(string)[]} an array of duration codes that are available for the current testSignalsCode
         */
        #supportedDurationOptions() {
            switch (this.testSignalsCode) {
                case TEST_SIGNAL_101:
                case TEST_SIGNAL_102:
                case TEST_SIGNAL_103:
                case TEST_SIGNAL_104:
                    return [this.#standardDuration.get(this.widthCode)];
                case TEST_SIGNAL_560:
                case TEST_SIGNAL_580:
                case TEST_SIGNAL_611:
                case TEST_SIGNAL_644:
                case TEST_SIGNAL_070:
                case TEST_SIGNAL_071:
                case TEST_SIGNAL_043:
                case TEST_SIGNAL_672:
                case TEST_SIGNAL_673:
                case TEST_SIGNAL_697:
                case TEST_SIGNAL_056:
                case TEST_SIGNAL_106:
                case TEST_SIGNAL_402:
                case TEST_SIGNAL_702:
                case TEST_SIGNAL_802:
                    return DURATION_LIST_SHORT_PROGRAM;
                case TEST_SIGNAL_570:
                    return [DURATION_4_MIN];
                case TEST_SIGNAL_NAB_190_380_274:
                case TEST_SIGNAL_NAB_190_380_010:
                case TEST_SIGNAL_NAB_190_380_015:
                case TEST_SIGNAL_NAB_190_380_008:
                case TEST_SIGNAL_IEC1_190_380_494:
                case TEST_SIGNAL_IEC1_190_380_016:
                case TEST_SIGNAL_IEC1_190_380_491:
                case TEST_SIGNAL_IEC1_380_760_486:
                case TEST_SIGNAL_IEC1_380_760_249:
                case TEST_SIGNAL_IEC1_380_760_005:
                case TEST_SIGNAL_IEC1_380_760_279:
                case TEST_SIGNAL_IEC1_380_760_487:
                case TEST_SIGNAL_IEC1_380_760_482:
                case TEST_SIGNAL_NAB_380_760_245:
                case TEST_SIGNAL_NAB_380_760_270:
                case TEST_SIGNAL_NAB_380_760_247:
                case TEST_SIGNAL_NAB_380_760_007:
                case TEST_SIGNAL_NAB_380_760_002:
                case TEST_SIGNAL_NAB_380_760_001:
                    return DURATION_LIST_DUAL_SPEED;
                case "999":
                    return [];
            }
        }

        supportedEqualizationDesignators() {
            return this.#supportedDesignators(
                this.#supportedEqualizationOptions(),
                EQUALIZATION_TO_LABEL_IMPERIAL,
                this.equalizationCodeV3);
        }

        #supportedEqualizationOptions() {
            if (this.testSignalsCode === TEST_SIGNAL_570) return this.#flutterEqualizationOptions();
            switch (this.speedCode) {
                case SPEED_CODE_SLOW: return [EQ_IEC_95, EQ_TEAC_EE_95];
                case SPEED_CODE_STANDARD: return [EQ_IEC1_190, EQ_NAB_190];
                case SPEED_CODE_FAST: return [EQ_IEC1_380, EQ_NAB_380];
                case SPEED_CODE_EXTRA_FAST: return [EQ_AES_760];
                case SPEED_CODE_DUAL_STANDARD: return [EQ_IEC1_190_380, EQ_NAB_190_380];
                case SPEED_CODE_DUAL_FAST: return [EQ_IEC1_380_760, EQ_NAB_380_760];
            }
        }

        /**
         * @returns {ProductDesignator[]}
         */
        supportedFringingCompensationDesignators() {
            return this.#supportedDesignators(
                this.#supportedFringingCompensationOptions(),
                fringingCodeToLabel,
                this.fringingCompensationCode
            );
        }

        /**
         * We only support the recommended fringing compensation options in the online store.
         * * 0.25" tapes -- fringing compensation is always disabled.
         * * 0.5" tapes -- both fringing compensation options are supported (disabled for 2-Track mastering).
         * * 1" and 2" tapes -- fringing compensation is always enabled.
         * * Flutter and speed tapes -- fringing compensation is always disabled.
         *
         * @returns {(string)[]|string[]}
         */
        #supportedFringingCompensationOptions() {
            if (this.testSignalsCode === TEST_SIGNAL_570) return [FRINGING_COMP_DISABLED];
            if (this.widthCode === WIDTH_CODE_6MM) return [FRINGING_COMP_DISABLED];
            if (this.widthCode === WIDTH_CODE_25MM) return [FRINGING_COMP_ENABLED];
            if (this.widthCode === WIDTH_CODE_50MM) return [FRINGING_COMP_ENABLED];
            return [FRINGING_COMP_DISABLED, FRINGING_COMP_ENABLED];
        }

        /**
         * @returns {ProductDesignator[]}
         */
        supportedAesFluxivityDesignators() {
            return this.#supportedDesignators(this.#supportedReferenceFluxivityAes7(), fluxivityCodeToAesLabel, this.referenceFluxivityCodeV3);
        }

        /**
         * @returns {ProductDesignator[]}
         */
        supportedGermanFluxivityDesignators() {
            return this.#supportedDesignators(this.#supportedReferenceFluxivityGerman(), fluxivityCodeToGermanLabel, this.referenceFluxivityCodeV3);
        }

        #supportedReferenceFluxivityAes7() {
            if (this.testSignalsCode === TEST_SIGNAL_570) return [REFERENCE_FLUXIVITY_48];
            switch (this.speedCode) {
                case SPEED_CODE_SLOW:
                    return REFERENCE_FLUXIVITIES_SLOW_ANSI;
                case SPEED_CODE_DUAL_STANDARD:
                case SPEED_CODE_STANDARD:
                    return REFERENCE_FLUXIVITIES_MEDIUM_ANSI;
                case SPEED_CODE_DUAL_FAST:
                case SPEED_CODE_EXTRA_FAST:
                case SPEED_CODE_FAST:
                    return REFERENCE_FLUXIVITIES_FAST_ANSI;
                default:
                    return REFERENCE_FLUXIVITIES_FAST_ANSI;
            }
        }

        #supportedReferenceFluxivityGerman() {
            if (this.testSignalsCode === TEST_SIGNAL_570) return [];
            switch (this.speedCode) {
                case SPEED_CODE_SLOW:
                    return REFERENCE_FLUXIVITIES_SLOW_GERMAN;
                case SPEED_CODE_DUAL_STANDARD:
                case SPEED_CODE_STANDARD:
                    return REFERENCE_FLUXIVITIES_MEDIUM_GERMAN;
                case SPEED_CODE_DUAL_FAST:
                case SPEED_CODE_EXTRA_FAST:
                case SPEED_CODE_FAST:
                    return REFERENCE_FLUXIVITIES_FAST_GERMAN;
                default:
                    return REFERENCE_FLUXIVITIES_FAST_GERMAN;
            }
        }

        supportedSpeedDesignators() {
            if (this.unitSystem === UNIT_SYSTEM_IMPERIAL) {
                return this.#supportedDesignators(this.#supportedPlaybackSpeedOptions(), SPEED_TO_LABEL_IMPERIAL, this.speedCode);
            } else {
                return this.#supportedDesignators(this.#supportedPlaybackSpeedOptions(), SPEED_TO_LABEL_METRIC, this.speedCode);
            }
        }

        #supportedPlaybackSpeedOptions() {
            if (this.testSignalsCode === TEST_SIGNAL_570) return this.#specialtyProgramSpeedOptions();
            if (this.testSignalsCode === TEST_SIGNAL_702) return this.#specialtyProgramSpeedOptions();
            if (this.testSignalsCode === TEST_SIGNAL_802) return this.#specialtyProgramSpeedOptions();
            switch (this.widthCode) {
                case WIDTH_CODE_6MM:
                    return SPEED_CODE_LIST_6MM;
                case WIDTH_CODE_12MM:
                    return SPEED_CODE_LIST_12MM;
                case WIDTH_CODE_25MM:
                    return SPEED_CODE_LIST_25MM;
                case WIDTH_CODE_50MM:
                    return SPEED_CODE_LIST_50MM;
                default:
                    return SPEED_CODE_LIST_ALL;
            }
        }

        /**
         * @returns {ProductDesignator[]}
         */
        supportedTestSignalDesignators() {
            return this.#supportedDesignators(this.#supportedTestSignalOptions(), testSignalToLabel, this.testSignalsCode);
        }

        #supportedTestSignalOptions() {
            switch (this.equalizationCodeV3) {
                case EQ_IEC_95:
                case EQ_TEAC_EE_95:
                case EQ_NAB_190:
                case EQ_IEC1_190:
                    return this.#supportedSlowTestSignalOptions();
                case EQ_NAB_380:
                case EQ_IEC1_380:
                case EQ_AES_760:
                    return this.#supportedFastTestSignalOptions();
                case EQ_IEC1_190_380:
                    return TEST_SIGNAL_LIST_IEC1_190_380;
                case EQ_NAB_190_380:
                    return TEST_SIGNAL_LIST_NAB_190_380;
                case EQ_IEC1_380_760:
                    return TEST_SIGNAL_LIST_IEC1_380_760;
                case EQ_NAB_380_760:
                    return TEST_SIGNAL_LIST_NAB_380_760;
                default:
                    return [];
            }
        }

        supportedUnitSystemDesignator() {
            return this.#supportedDesignators(UNIT_SYSTEMS, UNIT_SYSTEM_LABELS, this.unitSystem);
        }

        /**
         * @returns {ProductDesignator[]}
         */
        supportedWidthDesignator() {
            if (this.unitSystem === UNIT_SYSTEM_IMPERIAL) {
                return this.#supportedDesignators(WIDTHS_ALL, widthToLabelImperial, this.widthCode);
            } else {
                return this.#supportedDesignators(WIDTHS_ALL, widthToLabelMetric, this.widthCode);
            }
        }

        /**
         * Adapt the raw SKU codes in the `supportedOptions` to `ProductDesignator`s that the UI can consume to update
         * the Select HTML elements
         * @param supportedOptions {String[]}
         * @param labelMap {Map<String, String>} maps the SKU code to the label text to be shown in the UI
         * @param selectedValue {String} the currently selected designator (eg: width, speed, eq, etc)
         * @returns { ProductDesignator[] }
         */
        #supportedDesignators(supportedOptions, labelMap, selectedValue) {
            const toProductDesignator = (value, index, array) => {
                const isSelected = (value === selectedValue);
                return new ProductDesignator(value, isSelected, labelMap.get(value));
            };
            return supportedOptions.map(toProductDesignator);
        }

        updateDurationCode(durationElementValue) {
            this.durationCode = durationElementValue;
        }

        updateEqualizationCodeV3(equalizationElementValue) {
            if (this.equalizationCodeV3 === equalizationElementValue) return;
            this.equalizationCodeV3 = equalizationElementValue;
            this.#updateTestSignalsOptions();
        }

        updateReferenceFluxivityCode(referenceFluxivityElementValue) {
            this.referenceFluxivityCodeV3 = referenceFluxivityElementValue;
        }

        updateSpeedCode(playbackSpeedElementValue) {
            if (this.speedCode === playbackSpeedElementValue) return;
            this.speedCode = playbackSpeedElementValue;
            this.#updateReferenceFluxivityOptions();
            this.#updateEqualizationOptions();
            this.#updateTestSignalsOptions();
            this.#updateFringingCompensationOptions();
            this.#updateDurationOptions();
        }

        /**
         * Update the testSignalsCode itself
         * Update the list of supported durations
         * Update the currently selected duration if the previously selected duration is not on the new list of supported durations
         * @param testSignalsElementValue
         */
        updateTestSignalsCode(testSignalsElementValue) {
            if (this.testSignalsCode === testSignalsElementValue) return;
            this.testSignalsCode = testSignalsElementValue;
            this.#updateSpeedOptions();
            this.#updateEqualizationOptions();
            this.#updateReferenceFluxivityOptions();
            this.#resetFringingCompensation();
            this.#updateDurationOptions();
        }

        updateUnitSystem(unitSystem) {
            if (this.unitSystem === unitSystem) return;
            this.unitSystem = unitSystem;
        }

        updateWidthCode(widthElementValue) {
            if (this.widthCode === widthElementValue) return;
            this.widthCode = widthElementValue;
            this.#updateSpeedOptions();
            this.#updateEqualizationOptions();
            this.#updateTestSignalsOptions();
            this.#updateReferenceFluxivityOptions();
            this.#resetFringingCompensation();
            this.#updateDurationOptions();
        }

        #standardDuration = new Map([
            [WIDTH_CODE_6MM, DURATION_6_MIN],
            [WIDTH_CODE_12MM, DURATION_8_MIN],
            [WIDTH_CODE_25MM, DURATION_12_MIN],
            [WIDTH_CODE_50MM, DURATION_16_MIN],
        ]);

        /**
         * Generate the check digit based on the other digits of the SKU.
         *
         * Algorithm:
         * 1. Add up the weighted values of the first eleven SKU digits
         * 2. Divide by 10 and take the remainder
         * 3. Multiply by 9
         * 4. Divide by 10 and take the remainder again
         *
         * @returns {number} the check digit, which is the last digit of the 12-digit SKU
         */
        #checkDigit() {
            let accumulator = 0;
            const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3, 7];

            for (let n = 0; n < 11; n++) {
                accumulator += weights[n] * this.#skuV2CodeAt(n);
            }

            let x = accumulator % 10;
            x *= 9;
            x %= 10;
            return x;
        }

        #defaultFringingCompensationOption() {
            if (this.testSignalsCode === TEST_SIGNAL_570) return FRINGING_COMP_DISABLED;
            switch (this.widthCode) {
                case WIDTH_CODE_6MM: return FRINGING_COMP_DISABLED;
                case WIDTH_CODE_12MM:
                case WIDTH_CODE_25MM:
                case WIDTH_CODE_50MM:
                default: return FRINGING_COMP_ENABLED;
            }
        }

        /**
         * Maps the SKU v3 speed/eq code to the SKU v2 EQ code.
         *
         * @returns {string} the SKU code for equalization
         */
        #equalizationCodeV2() {
            switch (this.equalizationCodeV3) {
                case EQ_AES_760:
                case EQ_IEC_95:
                case EQ_IEC1_190:
                case EQ_IEC1_380:
                    return '1';
                case EQ_TEAC_EE_95:
                    return '2';
                case EQ_NAB_380:
                case EQ_NAB_190:
                    return '3';
                case EQ_NAB_190_380:
                case EQ_IEC1_190_380:
                case EQ_NAB_380_760:
                case EQ_IEC1_380_760:
                    return '9';
                default:
                    return '';
            }
        }

        /**
         * The SKU coding has this weird feature where we just give up and set the speed code to 9 for anything but single-speed tapes.
         * @returns {string} the SKU code for playback speed
         */
        #playbackSpeedCodeV2() {
            if (this.speedCode === "B") {
                return "9";
            }
            if (this.speedCode === "C") {
                return "9";
            }
            return this.speedCode;
        }

        /**
         * Convert SKU v3 EQ code to SKU v2 EQ code
         * @returns {string}
         */
        #referenceFluxivityCodeV2() {
            switch (this.referenceFluxivityCodeV3) {
                case "G2": return REFERENCE_FLUXIVITY_47;
                case "G3": return REFERENCE_FLUXIVITY_49;
                case "G5": return REFERENCE_FLUXIVITY_53;
                default: return this.referenceFluxivityCodeV3;
            }
        }

        /**
         * Reset the Fringing Compensation to the default value.
         */
        #resetFringingCompensation() {
            this.fringingCompensationCode = this.#defaultFringingCompensationOption();
        }

        /**
         * @param i
         * @returns {number|*|string}
         */
        #skuV2CodeAt(i) {
            switch (i) {
                case 0:
                    return this.widthCode;
                case 1:
                    return this.#playbackSpeedCodeV2();
                case 2:
                    return this.#equalizationCodeV2();
                case 3:
                    return this.testSignalsCode[0];
                case 4:
                    return this.testSignalsCode[1];
                case 5:
                    return this.testSignalsCode[2];
                case 6:
                    return this.#referenceFluxivityCodeV2()[0];
                case 7:
                    return this.#referenceFluxivityCodeV2()[1];
                case 8:
                    return this.fringingCompensationCode;
                case 9:
                    return this.packagingCode;
                case 10:
                    return this.durationCode;
            }
            return 0;
        }

        /**
         * Returns the supported CVV codes for fast single-speed tapes (15 & 30 ips)
         * @returns {(string)[]}
         */
        #supportedFastTestSignalOptions() {
            switch (this.widthCode) {
                case WIDTH_CODE_6MM:
                    return [TEST_SIGNAL_101, ...TEST_SIGNAL_LIST_SINGLE_SPEED];
                case WIDTH_CODE_12MM:
                case WIDTH_CODE_25MM:
                case WIDTH_CODE_50MM:
                    return [TEST_SIGNAL_103, ...TEST_SIGNAL_LIST_SINGLE_SPEED];
            }
        }

        /**
         * Returns the supported CVV codes for slow single-speed tapes (3¾ips & 7½ ips)
         * @returns {(string)[]}
         */
        #supportedSlowTestSignalOptions() {
            switch (this.widthCode) {
                case WIDTH_CODE_6MM:
                    return [TEST_SIGNAL_102, ...TEST_SIGNAL_LIST_SINGLE_SPEED];
                case WIDTH_CODE_12MM:
                case WIDTH_CODE_25MM:
                case WIDTH_CODE_50MM:
                    return [TEST_SIGNAL_104, ...TEST_SIGNAL_LIST_SINGLE_SPEED];
            }
        }

        #updateDurationOptions() {
            if (this.#supportedDurationOptions().includes(this.durationCode)) return;
            this.durationCode = this.#supportedDurationOptions().at(0);
        }

        #updateEqualizationOptions() {
            if (this.#supportedEqualizationOptions().includes(this.equalizationCodeV3)) return;
            const defaultEqualization = this.#supportedEqualizationOptions().at(0);
            if (defaultEqualization === undefined) { return; }
            this.equalizationCodeV3 = defaultEqualization.toString();
        }

        #updateFringingCompensationOptions() {
            if (this.#supportedFringingCompensationOptions().includes(this.fringingCompensationCode)) return;
            this.#resetFringingCompensation();
        }

        #updateTestSignalsOptions() {
            if (this.#supportedTestSignalOptions().includes(this.testSignalsCode)) return;
            const defaultTestSignals = this.#supportedTestSignalOptions().at(0);
            if (defaultTestSignals === undefined) { return; }
            this.testSignalsCode = defaultTestSignals.toString();
        }

        #updateReferenceFluxivityOptions() {
            if (this.#supportedReferenceFluxivityAes7().includes(this.referenceFluxivityCodeV3)) return;
            if (this.#supportedReferenceFluxivityGerman().includes(this.referenceFluxivityCodeV3)) return;
            this.referenceFluxivityCodeV3 = this.#defaultReferenceFluxivityOption();
        }

        /**
         * Take the last item from the referenceFluxivityList.
         * For the Flutter and Speed tape, we just return the only available fluxivity, 250nWb/m.
         */
        #defaultReferenceFluxivityOption() {
            if (this.testSignalsCode === TEST_SIGNAL_570) { return REFERENCE_FLUXIVITY_48; }
            if (REFERENCE_FLUXIVITIES_FAST_GERMAN.includes(this.referenceFluxivityCodeV3)) {
                return (this.#supportedReferenceFluxivityGerman())[this.#supportedReferenceFluxivityGerman().length - 1];
            }
            if (REFERENCE_FLUXIVITIES_FAST_ANSI.includes(this.referenceFluxivityCodeV3)) {
                return (this.#supportedReferenceFluxivityAes7())[this.#supportedReferenceFluxivityAes7().length - 1];
            }
            return REFERENCE_FLUXIVITY_48;
        }

        #updateSpeedOptions() {
            if (this.#supportedPlaybackSpeedOptions().includes(this.speedCode)) return;
            const defaultSpeed = this.#supportedPlaybackSpeedOptions().at(0);
            if (defaultSpeed === undefined) { return; }
            this.speedCode = defaultSpeed.toString();
        }

        /**
         * "Flutter and speed" tapes are only available with IEC EQ
         * @returns {string[]|*[]}
         */
        #flutterEqualizationOptions() {
            switch (this.speedCode) {
                case SPEED_CODE_SLOW: return [EQ_IEC_95];
                case SPEED_CODE_STANDARD: return [EQ_IEC1_190];
                case SPEED_CODE_FAST: return [EQ_IEC1_380];
                case SPEED_CODE_EXTRA_FAST: return [EQ_AES_760];
                case SPEED_CODE_DUAL_STANDARD: return [EQ_IEC1_190_380];
                case SPEED_CODE_DUAL_FAST: return [EQ_IEC1_380_760];
            }
        }

        #specialtyProgramSpeedOptions() {
            switch (this.widthCode) {
                case WIDTH_CODE_6MM:
                case WIDTH_CODE_12MM:
                case WIDTH_CODE_25MM: return [SPEED_CODE_SLOW, SPEED_CODE_STANDARD, SPEED_CODE_FAST, SPEED_CODE_EXTRA_FAST];
                case WIDTH_CODE_50MM: return [SPEED_CODE_STANDARD, SPEED_CODE_FAST, SPEED_CODE_EXTRA_FAST];
            }
        }
    }

    // ============================================================================
    // ViewModel Constants and Data Structures
    // ============================================================================

    const DURATION_4_MIN = "0";
    const DURATION_6_MIN = "1";
    const DURATION_8_MIN = "2";
    const DURATION_12_MIN = "3";
    const DURATION_16_MIN = "4";
    const DURATION_LIST_SHORT_PROGRAM = [DURATION_4_MIN, DURATION_8_MIN, DURATION_16_MIN];
    const DURATION_LIST_DUAL_SPEED = [DURATION_6_MIN, DURATION_12_MIN];
    const durationCodeToLabel = new Map([
        [DURATION_4_MIN, "4 min"],
        [DURATION_6_MIN, "5.7 min"],
        [DURATION_8_MIN, "8 min"],
        [DURATION_12_MIN, "11.3 min"],
        [DURATION_16_MIN, "16 min"],
    ]);

    /** 30 ips, AES  */
    const EQ_AES_760 = 'A';
    const EQ_IEC_95 = 'F';
    const EQ_TEAC_EE_95 = 'G';
    const EQ_NAB_190 = 'T';
    const EQ_IEC1_190 = 'V';
    const EQ_NAB_380 = 'J';
    const EQ_IEC1_380 = 'K';
    const EQ_IEC1_190_380 = 'X';
    const EQ_NAB_190_380 = 'Y';
    const EQ_IEC1_380_760 = 'W';
    const EQ_NAB_380_760 = 'Z';

    const EQUALIZATION_TO_LABEL_IMPERIAL = new Map([
        [EQ_AES_760, "AES (IEC2)"], // 30 in/s AES Eq.
        [EQ_IEC_95, "IEC & NAB"], // 3.75 in/s IEC Eq
        [EQ_TEAC_EE_95, "Teac EE"], // 3.75 in/s Teac EE Eq
        [EQ_NAB_380, "NAB (IEC2)"], // 15 in/s NAB Eq..
        [EQ_IEC1_380, "IEC1 (CCIR, DIN, IEC)"], // 15 in/s IEC Eq
        [EQ_NAB_190, "NAB (IEC2)"], //  7.5 in/s NAB Eq.
        [EQ_IEC1_190, "IEC1 (CCIR, DIN, IEC)"], // 7.5 in/s IEC Eq.
        [EQ_NAB_190_380, "NAB/NAB"], //  7.5 in/s NAB Eq., 15 in/s NAB Eq.
        [EQ_IEC1_190_380, "IEC/IEC"], //  7.5 in/s IEC Eq., 15 in/s IEC Eq.
        [EQ_NAB_380_760, "NAB/AES"], //  15 in/s NAB Eq., 30 in/s AES Eq.
        [EQ_IEC1_380_760, "IEC/AES"], //  15 in/s IEC Eq., 30 in/s AES Eq.
    ]);

    const FRINGING_COMP_DISABLED = "0";
    const FRINGING_COMP_ENABLED = "2";
    const fringingCodeToLabel = new Map([
        [FRINGING_COMP_DISABLED, "Disabled"],
        [FRINGING_COMP_ENABLED, "Enabled"],
    ]);

    const REFERENCE_FLUXIVITY_42 = "42" // 125 nWb/m
    const REFERENCE_FLUXIVITY_43 = "43" // 140 nWb/m
    const REFERENCE_FLUXIVITY_44 = "44" // 160 nWb/m
    const REFERENCE_FLUXIVITY_45 = "45" // 180 nWb/m
    const REFERENCE_FLUXIVITY_46 = "46" // 200 nWb/m
    const REFERENCE_FLUXIVITY_47 = "47" // 224 nWb/m
    const REFERENCE_FLUXIVITY_48 = "48" // 250 nWb/m
    const REFERENCE_FLUXIVITY_49 = "49" // 280 nWb/m
    const REFERENCE_FLUXIVITY_50 = "50" // 315 nWb/m
    const REFERENCE_FLUXIVITY_51 = "51" // 355 nWb/m
    const REFERENCE_FLUXIVITY_52 = "52" // 400 nWb/m
    const REFERENCE_FLUXIVITY_53 = "53" // 450 nWb/m
    const REFERENCE_FLUXIVITY_54 = "54" // 500 nWb/m
    const REFERENCE_FLUXIVITY_G2 = "G2" // 224 nWb/m
    const REFERENCE_FLUXIVITY_G3 = "G3" // 280 nWb/m
    const REFERENCE_FLUXIVITY_G5 = "G5" // 450 nWb/m

    const REFERENCE_FLUXIVITIES_SLOW_ANSI = [
        REFERENCE_FLUXIVITY_45,
        REFERENCE_FLUXIVITY_46,
        REFERENCE_FLUXIVITY_48
    ];
    const REFERENCE_FLUXIVITIES_MEDIUM_ANSI = [
        REFERENCE_FLUXIVITY_45,
        REFERENCE_FLUXIVITY_46,
        REFERENCE_FLUXIVITY_48,
        REFERENCE_FLUXIVITY_51,
    ];
    const REFERENCE_FLUXIVITIES_FAST_ANSI = [
        REFERENCE_FLUXIVITY_45,
        REFERENCE_FLUXIVITY_46,
        REFERENCE_FLUXIVITY_48,
        REFERENCE_FLUXIVITY_51,
        REFERENCE_FLUXIVITY_54,
    ];
    const REFERENCE_FLUXIVITIES_SLOW_GERMAN = [REFERENCE_FLUXIVITY_G2];
    const REFERENCE_FLUXIVITIES_MEDIUM_GERMAN = [
        REFERENCE_FLUXIVITY_G2,
        REFERENCE_FLUXIVITY_G3
    ];
    const REFERENCE_FLUXIVITIES_FAST_GERMAN = [
        REFERENCE_FLUXIVITY_G2,
        REFERENCE_FLUXIVITY_G3,
        REFERENCE_FLUXIVITY_G5
    ];

    const fluxivityCodeToAesLabel = new Map([
        [REFERENCE_FLUXIVITY_42, "125 nWb/m"],
        [REFERENCE_FLUXIVITY_43, "140 nWb/m"],
        [REFERENCE_FLUXIVITY_44, "160 nWb/m"],
        [REFERENCE_FLUXIVITY_45, "180 nWb/m"],
        [REFERENCE_FLUXIVITY_46, "200 nWb/m"],
        [REFERENCE_FLUXIVITY_47, "224 nWb/m"],
        [REFERENCE_FLUXIVITY_48, "250 nWb/m"],
        [REFERENCE_FLUXIVITY_49, "280 nWb/m"],
        [REFERENCE_FLUXIVITY_50, "315 nWb/m"],
        [REFERENCE_FLUXIVITY_51, "355 nWb/m"],
        [REFERENCE_FLUXIVITY_52, "400 nWb/m"],
        [REFERENCE_FLUXIVITY_53, "450 nWb/m"],
        [REFERENCE_FLUXIVITY_54, "500 nWb/m"],
    ]);

    const fluxivityCodeToGermanLabel = new Map([
        [REFERENCE_FLUXIVITY_G2, "G250 (224 nWb/m)"],
        [REFERENCE_FLUXIVITY_G3, "G320 (280 nWb/m)"],
        [REFERENCE_FLUXIVITY_G5, "G510 (450 nWb/m)"],
    ]);

    const SPEED_CODE_SLOW = "2";
    const SPEED_CODE_STANDARD = "3";
    const SPEED_CODE_FAST = "4";  // 15 ips
    const SPEED_CODE_EXTRA_FAST = "5";
    const SPEED_CODE_DUAL_STANDARD = "B";
    const SPEED_CODE_DUAL_FAST = "C";

    const SPEED_TO_LABEL_IMPERIAL = new Map([
        [SPEED_CODE_SLOW, "3¾ in/s"],
        [SPEED_CODE_STANDARD, "7½ in/s"],
        [SPEED_CODE_FAST, "15 in/s"],
        [SPEED_CODE_EXTRA_FAST, "30 in/s"],
        [SPEED_CODE_DUAL_STANDARD, "7½ & 15 in/s"],
        [SPEED_CODE_DUAL_FAST, "15 & 30 in/s"],
    ]);

    const SPEED_TO_LABEL_METRIC = new Map([
        [SPEED_CODE_SLOW, "95 mm/s"],
        [SPEED_CODE_STANDARD, "190 mm/s"],
        [SPEED_CODE_FAST, "380 mm/s"],
        [SPEED_CODE_EXTRA_FAST, "760 mm/s"],
        [SPEED_CODE_DUAL_STANDARD, "190 & 380 mm/s"],
        [SPEED_CODE_DUAL_FAST, "380 & 760 mm/s"],
    ]);

    const SPEED_CODE_LIST_ALL = [
        SPEED_CODE_SLOW,
        SPEED_CODE_STANDARD,
        SPEED_CODE_FAST,
        SPEED_CODE_EXTRA_FAST,
        SPEED_CODE_DUAL_STANDARD,
        SPEED_CODE_DUAL_FAST,
    ];

    const SPEED_CODE_LIST_6MM = [
        SPEED_CODE_SLOW,
        SPEED_CODE_STANDARD,
        SPEED_CODE_FAST,
        SPEED_CODE_EXTRA_FAST,
        SPEED_CODE_DUAL_STANDARD,
        SPEED_CODE_DUAL_FAST,
    ];

    const SPEED_CODE_LIST_12MM = [
        SPEED_CODE_SLOW,
        SPEED_CODE_STANDARD,
        SPEED_CODE_FAST,
        SPEED_CODE_EXTRA_FAST,
        SPEED_CODE_DUAL_STANDARD,
        SPEED_CODE_DUAL_FAST,
    ];

    const SPEED_CODE_LIST_25MM = [
        SPEED_CODE_STANDARD,
        SPEED_CODE_FAST,
        SPEED_CODE_EXTRA_FAST,
        SPEED_CODE_DUAL_FAST,
    ];

    const SPEED_CODE_LIST_50MM = [
        SPEED_CODE_STANDARD,
        SPEED_CODE_FAST,
        SPEED_CODE_EXTRA_FAST,
        SPEED_CODE_DUAL_STANDARD,
        SPEED_CODE_DUAL_FAST,
    ];

    const TEST_SIGNAL_101 = "101";
    const TEST_SIGNAL_102 = "102";
    const TEST_SIGNAL_103 = "103";
    const TEST_SIGNAL_104 = "104";
    const TEST_SIGNAL_043 = "043";
    const TEST_SIGNAL_056 = "056";
    const TEST_SIGNAL_070 = "070";
    const TEST_SIGNAL_071 = "071";
    const TEST_SIGNAL_106 = "106";
    const TEST_SIGNAL_402 = "402";
    const TEST_SIGNAL_560 = "560";
    const TEST_SIGNAL_580 = "580";
    const TEST_SIGNAL_611 = "611";
    const TEST_SIGNAL_644 = "644";
    const TEST_SIGNAL_672 = "672";
    const TEST_SIGNAL_673 = "673";
    const TEST_SIGNAL_697 = "697";
    const TEST_SIGNAL_570 = "570";
    const TEST_SIGNAL_702 = "702"; // Broadband white noise
    const TEST_SIGNAL_802 = "802"; // Broadband pink noise

    const TEST_SIGNAL_LIST_SINGLE_SPEED = [
        TEST_SIGNAL_560,
        TEST_SIGNAL_580,
        TEST_SIGNAL_611,
        TEST_SIGNAL_644,
        TEST_SIGNAL_070,
        TEST_SIGNAL_071,
        TEST_SIGNAL_043,
        TEST_SIGNAL_672,
        TEST_SIGNAL_673,
        TEST_SIGNAL_697,
        TEST_SIGNAL_570,
        TEST_SIGNAL_402,
        TEST_SIGNAL_802,
        TEST_SIGNAL_702,
    ];

    const TEST_SIGNAL_IEC1_190_380_494 = "494";
    const TEST_SIGNAL_IEC1_190_380_016 = "016";
    const TEST_SIGNAL_IEC1_190_380_491 = "491";
    const TEST_SIGNAL_LIST_IEC1_190_380 = [
        TEST_SIGNAL_IEC1_190_380_494,
        TEST_SIGNAL_IEC1_190_380_016,
        TEST_SIGNAL_IEC1_190_380_491,
    ];

    const TEST_SIGNAL_NAB_190_380_274 = "274";
    const TEST_SIGNAL_NAB_190_380_010 = "010";
    const TEST_SIGNAL_NAB_190_380_015 = "015";
    const TEST_SIGNAL_NAB_190_380_008 = "008";
    const TEST_SIGNAL_LIST_NAB_190_380 = [
        TEST_SIGNAL_NAB_190_380_274,
        TEST_SIGNAL_NAB_190_380_010,
        TEST_SIGNAL_NAB_190_380_015,
        TEST_SIGNAL_NAB_190_380_008,
    ];

    const TEST_SIGNAL_IEC1_380_760_486 = "486";
    const TEST_SIGNAL_IEC1_380_760_249 = "249";
    const TEST_SIGNAL_IEC1_380_760_005 = "005";
    const TEST_SIGNAL_IEC1_380_760_279 = "279";
    const TEST_SIGNAL_IEC1_380_760_487 = "487";
    const TEST_SIGNAL_IEC1_380_760_482 = "482";
    const TEST_SIGNAL_LIST_IEC1_380_760 = [
        TEST_SIGNAL_IEC1_380_760_486,
        TEST_SIGNAL_IEC1_380_760_249,
        TEST_SIGNAL_IEC1_380_760_005,
        TEST_SIGNAL_IEC1_380_760_279,
        TEST_SIGNAL_IEC1_380_760_487,
        TEST_SIGNAL_IEC1_380_760_482,
    ];

    const TEST_SIGNAL_NAB_380_760_245 = "245";
    const TEST_SIGNAL_NAB_380_760_270 = "270";
    const TEST_SIGNAL_NAB_380_760_247 = "247";
    const TEST_SIGNAL_NAB_380_760_007 = "007";
    const TEST_SIGNAL_NAB_380_760_002 = "002";
    const TEST_SIGNAL_NAB_380_760_001 = "001";
    const TEST_SIGNAL_LIST_NAB_380_760 = [
        TEST_SIGNAL_NAB_380_760_245,
        TEST_SIGNAL_NAB_380_760_270,
        TEST_SIGNAL_NAB_380_760_247,
        TEST_SIGNAL_NAB_380_760_007,
        TEST_SIGNAL_NAB_380_760_002,
        TEST_SIGNAL_NAB_380_760_001,
    ];

    const testSignalToLabel = new Map([
        [TEST_SIGNAL_101, "Full Program (13-Freq: 32Hz..20kHz)"],
        [TEST_SIGNAL_102, "Full Program (13-Freq: 32Hz..20kHz)"],
        [TEST_SIGNAL_103, "Full Program (13-Freq: 32Hz..20kHz)"],
        [TEST_SIGNAL_104, "Full Program (13-Freq: 32Hz..20kHz)"],
        [TEST_SIGNAL_560, "1-Freq: 1k"],
        [TEST_SIGNAL_580, "1-Freq: 10k"],
        [TEST_SIGNAL_611, "2-Freq: 1k, 10k"],
        [TEST_SIGNAL_644, "3-Freq: 1k, 10k, 100"],
        [TEST_SIGNAL_070, "3-Freq: 1k, 10k, 50"],
        [TEST_SIGNAL_071, "3-Freq: 1k, 10k, 5k"],
        [TEST_SIGNAL_043, "4-Freq: 1k, 10k, 16k, 50"],
        [TEST_SIGNAL_672, "4-Freq: 1k, 10k, 16k, 63"],
        [TEST_SIGNAL_673, "4-Freq: 1k, 10k, 16k, 100"],
        [TEST_SIGNAL_697, "5-Freq: 1k, 10k, 16k, 100, 50"],
        [TEST_SIGNAL_056, "6-Freq: 1k, 10k, 16k, 20k, 100, 50"],
        [TEST_SIGNAL_106, "6-Freq: 1k, 12.5k, 8k, 1k, 125, 63"],
        [TEST_SIGNAL_570, "Flutter and Speed Test: 3150 Hz"],
        [TEST_SIGNAL_402, "Slow Sweep"],
        [TEST_SIGNAL_702, "White Noise"],
        [TEST_SIGNAL_802, "Pink Noise"],
        [TEST_SIGNAL_NAB_190_380_274, "2-Freq: 1k, 10k"],
        [TEST_SIGNAL_NAB_190_380_010, "3-Freq: 1k, 10k, 100"],
        [TEST_SIGNAL_NAB_190_380_015, "4-Freq: 1k, 10k, 16k, 100"],
        [TEST_SIGNAL_NAB_190_380_008, "6-Freq: 1k, 10k, 50, 100, 8k, 16k"],
        [TEST_SIGNAL_IEC1_190_380_494, "3-Freq: 1k, 10k, 100"],
        [TEST_SIGNAL_IEC1_190_380_016, "4-Freq: 1k, 10k, 16k, 100"],
        [TEST_SIGNAL_IEC1_190_380_491, "6-Freq: 1k, 10k, 50, 100, 8k, 16k"],
        [TEST_SIGNAL_IEC1_380_760_486, "3-Freq: 1k, 10k, 16k"],
        [TEST_SIGNAL_IEC1_380_760_249, "3-Freq: 1k, 10k, 100"],
        [TEST_SIGNAL_IEC1_380_760_005, "4-Freq: 1k, 100, 10k, 16k"],
        [TEST_SIGNAL_IEC1_380_760_279, "5-Freq: 1k, 100, 4k, 10k, 16k"],
        [TEST_SIGNAL_IEC1_380_760_487, "5-Freq: 1k, 10k, 16k, 100, 50"],
        [TEST_SIGNAL_IEC1_380_760_482, "6-Freq: 1k, 8k, 16k, 10k, 100, 50"],
        [TEST_SIGNAL_NAB_380_760_245, "2-Freq: 1k, 10k"],
        [TEST_SIGNAL_NAB_380_760_270, "3-Freq: 1k, 10k, 16k"],
        [TEST_SIGNAL_NAB_380_760_247, "3-Freq: 1k, 10k, 100"],
        [TEST_SIGNAL_NAB_380_760_007, "4-Freq: 1k, 10k, 16k, 100"],
        [TEST_SIGNAL_NAB_380_760_002, "5-Freq: 1k, 10k, 16k, 100, 50"],
        [TEST_SIGNAL_NAB_380_760_001, "5-Freq: 1k, 10k, 16k, 100, 63"],
    ]);

    const UNIT_SYSTEM_IMPERIAL = "imperial";
    const UNIT_SYSTEM_METRIC = "metric";
    const UNIT_SYSTEMS = [UNIT_SYSTEM_METRIC, UNIT_SYSTEM_IMPERIAL];
    const UNIT_SYSTEM_LABELS = new Map([
        [UNIT_SYSTEM_METRIC, "Metric"],
        [UNIT_SYSTEM_IMPERIAL, "Imperial"],
    ]);

    const WIDTH_CODE_6MM = "2";
    const WIDTH_CODE_12MM = "3";
    const WIDTH_CODE_25MM = "4";
    const WIDTH_CODE_50MM = "5";
    const WIDTHS_ALL = [WIDTH_CODE_6MM, WIDTH_CODE_12MM, WIDTH_CODE_25MM, WIDTH_CODE_50MM];

    const widthToLabelImperial = new Map([
        [WIDTH_CODE_6MM, "¼ in"],
        [WIDTH_CODE_12MM, "½ in"],
        [WIDTH_CODE_25MM, "1 in"],
        [WIDTH_CODE_50MM, "2 in"],
    ]);

    const widthToLabelMetric = new Map([
        [WIDTH_CODE_6MM, "6 mm"],
        [WIDTH_CODE_12MM, "12 mm"],
        [WIDTH_CODE_25MM, "25 mm"],
        [WIDTH_CODE_50MM, "50 mm"],
    ]);

    // ============================================================================
    // Product Selector UI Controller
    // ============================================================================

    /**
     * Initialize all the dropdowns and SKU display.
     */
    function updateProductSelectorState() {
        updateDurationOptions();
        updateEqualizationOptions();
        updateFringingCompensationOptions();
        updateReferenceFluxivityOptions();
        updateSpeedOptions();
        updateWidthOptions();
        updateTestSignalOptions();
        updateSku();
        updateUnitSystem();
    }

    /** Update SKU when duration changes. */
    function handleDurationEvent(durationElementValue) {
        viewModel.updateDurationCode(durationElementValue);
        updateProductSelectorState();
    }

    /** Update SKU when equalization changes. */
    function handleEqualizationEvent(equalizationElementValue) {
        viewModel.updateEqualizationCodeV3(equalizationElementValue);
        updateProductSelectorState();
    }

    /** Update SKU when fringing compensation changes. */
    function handleFringingCompensationEvent(fringingCompensationElementValue) {
        viewModel.fringingCompensationCode = fringingCompensationElementValue;
        updateProductSelectorState();
    }

    /** Update SKU and dropdown visibilities when playback speed changes. */
    function handlePlaybackSpeedEvent(playbackSpeedElementValue) {
        viewModel.updateSpeedCode(playbackSpeedElementValue);
        updateProductSelectorState();
    }

    /** Update SKU and the relative Reference Fluxivity when reference fluxivity changes. */
    function handleReferenceFluxivityEvent(referenceFluxivityElementValue) {
        viewModel.updateReferenceFluxivityCode(referenceFluxivityElementValue);
        updateProductSelectorState();
    }

    /** Update SKU and dropdown visibilities when tape width changes. */
    function handleTapeWidthEvent(widthElementValue) {
        viewModel.updateWidthCode(widthElementValue);
        updateProductSelectorState();
    }

    /** Update SKU and the Duration dropdown when test signals (CVV) changes. */
    function handleTestSignalsEvent(testSignalsElementValue) {
        viewModel.updateTestSignalsCode(testSignalsElementValue);
        updateProductSelectorState();
    }

    function handleUnitSystemEvent(value) {
        viewModel.updateUnitSystem(value);
        updateProductSelectorState();
    }

    /** Show the available duration options, and update the selected option, if necessary. */
    function updateDurationOptions() {
        updateDesignators(durationElement(), viewModel.supportedDurationDesignators());
    }

    /** Show the available equalization options, and update the selected option, if necessary. */
    function updateEqualizationOptions() {
        updateDesignators(equalizationElement(), viewModel.supportedEqualizationDesignators());
    }

    /** Show the available fringing compensation options, and update the selected option, if necessary. */
    function updateFringingCompensationOptions() {
        updateDesignators(fringingCompensationElement(), viewModel.supportedFringingCompensationDesignators());
    }

    function updateReferenceFluxivityDb() {
        referenceFluxivityDbElement().innerHTML = viewModel.referenceFluxivityDb();
    }

    /** Show/hide the German Standard selector group. */
    function updateFluxivityGroups() {
        fluxivityGroupGerman().hidden = !viewModel.isGermanFluxivityGroupVisible();
    }

    /** Show the available reference fluxivity options, and update the selected option, if necessary. */
    function updateReferenceFluxivityOptions() {
        updateOptGroup(fluxivityGroupAes(), viewModel.supportedAesFluxivityDesignators());
        updateOptGroup(fluxivityGroupGerman(), viewModel.supportedGermanFluxivityDesignators());
        updateFluxivityGroups();
        updateReferenceFluxivityDb();
    }

    /**
     * Update the SKU and corresponding link.
     *
     * Uses Shopify's Ajax API to find the product by SKU and link directly to the product page
     * with the specific variant pre-selected.
     * If the product is not found, falls back to linking to the search results page.
     *
     * Clicking the direct product link takes the user straight to the product page with the
     * correct variant already selected.
     * Clicking the search link is functionally equivalent to entering the SKU into the search box in the navigation bar.
     */
        // Store current product result for buy button
    let currentProductResult = null;

    async function updateSku() {
        const sku = viewModel.sku();
        skuElement().innerHTML = sku;

        // Add loading state
        skuElement().classList.add('loading');
        buyButtonElement().disabled = true;
        buyButtonElement().textContent = 'Loading...';
        productPageButtonElement().disabled = true;
        productPageButtonElement().textContent = 'Loading...';
        buyMessageElement().textContent = '';

        // Try to find product by SKU
        const result = await findProductBySku(sku);
        currentProductResult = result; // Store for buy button

        if (result && result.handle && result.variantId) {
            // Direct link to product page with specific variant
            skuElement().href = `/products/${result.handle}?variant=${result.variantId}`;
            skuElement().title = `View ${sku} product page`;

            // Enable buy button
            buyButtonElement().disabled = false;
            buyButtonElement().textContent = 'Add to Cart';

            // Enable product page button
            productPageButtonElement().disabled = false;
            productPageButtonElement().textContent = 'View Product Page';
        } else {
            // Fallback to search if product not found
            skuElement().href = `/search?type=product&q=${encodeURIComponent(sku)}`;
            skuElement().title = `Search for ${sku}`;

            // Disable buy button
            buyButtonElement().disabled = true;
            buyButtonElement().textContent = 'Product Not Found';

            // Disable product page button
            productPageButtonElement().disabled = true;
            productPageButtonElement().textContent = 'Product Not Found';
        }

        // Remove loading state
        skuElement().classList.remove('loading');
    }

    /**
     * Add the currently selected product variant to the cart
     * Uses Shopify's AJAX Cart API
     */
    async function addToCart() {
        if (!currentProductResult || !currentProductResult.variantId) {
            buyMessageElement().textContent = 'Please select a product first';
            buyMessageElement().className = 'buy-message error';
            return;
        }

        // Show loading state
        buyButtonElement().disabled = true;
        buyButtonElement().textContent = 'Adding...';
        buyMessageElement().textContent = '';

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: currentProductResult.variantId,
                    quantity: 1
                })
            });

            if (!response.ok) {
                throw new Error('Failed to add to cart');
            }

            const data = await response.json();

            console.log('Added to cart:', data);

            // Show success message
            buyButtonElement().textContent = 'Added to Cart!';
            buyMessageElement().textContent = '✓ Successfully added to cart';
            buyMessageElement().className = 'buy-message success';

            // Reset button after 2 seconds
            setTimeout(() => {
                buyButtonElement().textContent = 'Add to Cart';
                buyButtonElement().disabled = false;
            }, 2000);

        } catch (error) {
            console.error('Error adding to cart:', error);

            // Show error message
            buyButtonElement().textContent = 'Add to Cart';
            buyButtonElement().disabled = false;
            buyMessageElement().textContent = '✗ Failed to add to cart. Please try again.';
            buyMessageElement().className = 'buy-message error';
        }
    }

    /**
     * Navigate to the product page with the specific variant
     */
    function navigateToProductPage() {
        if (!currentProductResult || !currentProductResult.handle || !currentProductResult.variantId) {
            console.warn('No product to navigate to');
            return;
        }

        const url = `/products/${currentProductResult.handle}?variant=${currentProductResult.variantId}`;
        window.location.href = url;
    }

    /** Add/remove the available playback speed options, and update the selected option. */
    function updateSpeedOptions() {
        updateDesignators(playbackSpeedElement(), viewModel.supportedSpeedDesignators());
    }

    /** Show the available Test Signal options, and update the selected option, if necessary. */
    function updateTestSignalOptions() {
        updateDesignators(testSignalsElement(), viewModel.supportedTestSignalDesignators());
    }

    /**
     * Update the unit system UI to match the ViewModel.
     */
    function updateUnitSystem() {
        viewModel.supportedUnitSystemDesignator().forEach((designator) => {
            const inputElement = document.querySelector(`input[value="${designator.value}"]`);
            if (designator.isSelected) inputElement.checked = true;
        });
    }

    /** Add/remove the available tape width options, and update the selected option. */
    function updateWidthOptions() {
        updateDesignators(tapeWidthElement(), viewModel.supportedWidthDesignator());
    }

    /**
     * Update options that are available for the given designator.
     */
    function updateDesignators(selectElement, productDesignators) {
        selectElement.options.length = 0;
        productDesignators.forEach((designator) => {
            selectElement.add(new Option(designator.label, designator.value, false, designator.isSelected));
        });
    }

    /**
     * @param optGroupElement {HTMLOptGroupElement}
     * @param productDesignators {ProductDesignator[]}
     */
    function updateOptGroup(optGroupElement, productDesignators) {
        optGroupElement.innerHTML = '';
        productDesignators.forEach((designator) => {
            optGroupElement.appendChild(new Option(designator.label, designator.value, false, designator.isSelected));
        });
    }

    function findById(elementId) { return document.getElementById(elementId); }

    function durationElement() { return findById('duration'); }
    function equalizationElement() { return findById('equalization'); }
    function fluxivityGroupGerman() { return findById('fluxivity_group_german'); }
    function fluxivityGroupAes() { return findById('fluxivity_group_aes'); }
    function fringingCompensationElement() { return findById('fringing_compensation'); }
    function playbackSpeedElement() { return findById('playback_speed'); }
    function referenceFluxivityDbElement() { return findById('relative_fluxivity'); }
    function referenceFluxivityElement() { return findById('reference_fluxivity'); }
    function skuElement() { return findById("sku"); }
    function buyButtonElement() { return findById("buy-button"); }
    function productPageButtonElement() { return findById("product-page-button"); }
    function buyMessageElement() { return findById("buy-message"); }
    function tapeWidthElement() { return findById('tape_width'); }
    function testSignalsElement() { return findById('test_signals'); }
    function unitSystemElement() { return findById('unit_system'); }

    // ============================================================================
    // Event Listeners
    // ============================================================================

    durationElement().addEventListener('change', function(event) {
        handleDurationEvent(event.target.value);
    });

    equalizationElement().addEventListener('change', function(event) {
        handleEqualizationEvent(event.target.value);
    });

    fringingCompensationElement().addEventListener('change', function(event) {
        handleFringingCompensationEvent(event.target.value);
    });

    playbackSpeedElement().addEventListener('change', function(event) {
        handlePlaybackSpeedEvent(event.target.value);
    });

    referenceFluxivityElement().addEventListener('change', function(event) {
        handleReferenceFluxivityEvent(event.target.value);
    });

    tapeWidthElement().addEventListener('change', function(event) {
        handleTapeWidthEvent(event.target.value);
    });

    testSignalsElement().addEventListener('change', function(event) {
        handleTestSignalsEvent(event.target.value);
    });

    unitSystemElement().addEventListener('change', function(event) {
        const selectedValue = unitSystemElement().querySelector('input[name="unit_system_option"]:checked').value;
        handleUnitSystemEvent(selectedValue);
    });

    // Buy button click handler
    buyButtonElement().addEventListener('click', function(event) {
        event.preventDefault();
        addToCart();
    });

    // Product page button click handler
    productPageButtonElement().addEventListener('click', function(event) {
        event.preventDefault();
        navigateToProductPage();
    });

    // ============================================================================
    // Initialize
    // ============================================================================

    const viewModel = new ViewModel();
    updateProductSelectorState();

})();
